import React, { useState, useLayoutEffect, useEffect } from "react";
import RenderDocDetailsProps from "./RenderDocDetailsProps";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import UserCmDoc from "../../entities/UserCMDoc";
import DetailsNotFound from "../DetailsNotFound/DetailsNotFound";
import DocDetails from "../DocDetails/DocDetails";
import LetterOption from "../LettersReports/LetterOption";
import {
  filterByDate,
  filterDepositsByDate,
  filterMasByDate,
} from "../../utils/helpers/filterByDate";
import {
  setLatestEndDate,
  setLatestRadioValue,
  setLatestStartDate,
  setLatestTab,
} from "../../state/actions/LettersReportsActions";
import {
  TLUSHI_PENSION,
  LETTERS_REPORTS,
  PENSION_REPORTS,
  MAS_CONFIRMS,
  DOCS_101,
} from "../../utils/constants/LettersReportsConstants";
import UserMasConfirm from "../../entities/UserMasConfirm";
import MasConfirms from "../MasConfirms/MasConfirms";
import MessageOption from "../LettersReports/MessageOption";
import DepositData from "../../entities/DepositData";
import useDidMountEffect from "../../customHooks/useDidMountEffect";
import { getUserFunds } from "../../services/getUserFunds";
import { getFunds } from "../../services/Deposit.service";

const RenderDocDetails = (props: RenderDocDetailsProps) => {
  const [userMainReports, setUserMainReports] = useState(props.userCmReports);
  const [userAttachedReports, setUserAttachedReports] = useState([]);
  const [funds, setFunds] = useState<any>([]);
  const [mapUserFundsn, setmapUserFundsn] = useState<any>([]);
  const currentActiveTab = useSelector(
    (state: any) => state.LettersReportsReducer.currentActiveTab
  );
  const { mapUserFunds ,  userFunds} = useSelector((state: any) => state.UserReducer);
  const { t } = useTranslation("common");
  const dispatch = useDispatch();

  const handleSetUserReports = async (
    startDate: Date | string | number,
    endDate: Date | string | number
  ) => {
    // Handle set user reports array by renderLabel prop
    // by renderLabel value, for each report make their own logic
    // and filter data by start and end date's.
    switch (props.renderLabel) {
      case TLUSHI_PENSION:
        if (props.from106Docs) {
          const Docs106 = props.userCmReports.filter(
            (tlushPension: UserCmDoc) =>
              tlushPension.DocDate.split("-")[1] === "12"
          );
          setUserMainReports(filterByDate(Docs106, startDate, endDate));
        } else {
          setUserMainReports(
            filterByDate(props.userCmReports, startDate, endDate)
          );
        }
        break;
      case PENSION_REPORTS:
        const mainReports: UserCmDoc[] = props.userCmReports.filter(
          (doc: UserCmDoc) => !doc.DocDisplayName.includes("נספח לדוח לחבר")
        );
        const attachedReports: UserCmDoc[] = props.userCmReports.filter(
          (doc: UserCmDoc) => doc.DocDisplayName.includes("נספח לדוח לחבר")
        );
        setUserMainReports(filterByDate(mainReports, startDate, endDate));
        setUserAttachedReports(
          filterByDate(attachedReports, startDate, endDate)
        );
        break;
      case LETTERS_REPORTS:
        setUserMainReports(
          filterByDate(props.userCmReports, startDate, endDate)
        );
        const userDepositMessages = props.userDepositsMessages.sort((a:any,b:any)=>{
          return   new Date(b.depositDate).valueOf()- new Date(a.depositDate).valueOf();
        });
        setUserAttachedReports(
          filterDepositsByDate(userDepositMessages, startDate, endDate)
        );
        break;
      case DOCS_101:
        setUserMainReports(
          filterByDate(props.userCmReports, startDate, endDate)
        );
        break;
      case MAS_CONFIRMS:
        let today = new Date();
        today.setFullYear(today.getFullYear() - 10);
        today.setMonth(0);
        today.setDate(1);
        setUserMainReports(
          filterMasByDate(props.userCmReports, today , new Date().toLocaleDateString())
        );
        break;
      default:
        return;
    }
  };

  const getFundsApi = async () => {
    const response:any = await getFunds();
    if(response.status === 200 && response.data.errorCode === 0){
        setFunds(response.data.funds)
    }

  } 

  React.useEffect(() => {
    getFundsApi();
  }, [])

  React.useEffect(() => {
    if(!(mapUserFunds instanceof Map)){
      let mapUserFunds =  new Map(
        userFunds.map((obj:any) => {
          return [obj.fundCode, obj];
        }),
      );
      setmapUserFundsn(mapUserFunds)
    }
  }, [userFunds])
    useEffect(() => {
      // Handle dependencies changes, and filter the current array
      // by radio value and date's.
      filterMainReports();
      // eslint-disable-next-line
    }, [
      props,
      props.userCmReports,
      props.renderLabel,
      props.from106Docs,
      props.radioValue,
      props.startDateValue,
      props.endDateValue,
    ]);
  
    useEffect(() => {
      // Track the last successful filter and store it in LettersReports store
      if (userMainReports && userMainReports.length) {
        trackLastSuccessfulResult();
      }
    }, [userMainReports || userMainReports?.length]);

  const handleRenderUserReports = () => {
    // Handle the UI render by renderLabel prop
    // by renderLabel value, for each report type render his ui

    switch (props.renderLabel) {
      case TLUSHI_PENSION:
        return userMainReports?.map((mainDoc: UserCmDoc, index: number) => (
          <DocDetails mainDoc={mainDoc} fromTlushiPension={true} key={index} fundName={funds} />
        ));
      case PENSION_REPORTS:
        return userMainReports?.map((mainDoc: UserCmDoc, index: number) => (
          <DocDetails
            mainDoc={mainDoc}
            userAttachedReports={userAttachedReports}
            fromReports={true}
            key={index}
            fundName={funds}
          />
        ));
      case LETTERS_REPORTS:
        return (
          <div className="letter-page">
            {userAttachedReports?.map(
              (depositMessage: DepositData, index: number) => (
                <MessageOption depositMessage={depositMessage} key={index} />
              )
            )}
            {userMainReports?.map((cmLetter: UserCmDoc, index: number) => (
              <LetterOption cmLetter={cmLetter} key={index} fundName={funds} />
            ))}
          </div>
        );
      case DOCS_101:
        return userMainReports?.map((mainDoc: UserCmDoc, index: number) => (
          <DocDetails mainDoc={mainDoc} key={index} />
        ));
      case MAS_CONFIRMS:
        return userMainReports?.map(
          (masConfirm: UserMasConfirm, index: number ) => (
            (mapUserFunds instanceof Map &&  mapUserFunds.has(masConfirm.fundcode)) || (mapUserFundsn instanceof Map && mapUserFundsn.has(masConfirm.fundcode))?
              <MasConfirms 
              masConfirm={masConfirm} 
              key={index} 
              FundLabels={mapUserFunds instanceof Map ? mapUserFunds?.get(`${masConfirm.fundcode}`) : mapUserFundsn instanceof Map ? mapUserFundsn?.get(`${masConfirm.fundcode}`) : ""}
               />:null
            
          )
        );
    }
  };



  const filterMainReports = async () => {
    // Filter current main reports array by radio value and dates.
    if (props.radioValue === t("LettersReports.radioValue1")) {
      const endDate: Date | string = new Date().toLocaleDateString();
      let startDate: Date | string = new Date();
      startDate = new Date(startDate.getFullYear() , startDate.getMonth() -12, 1);
      startDate = startDate.toLocaleDateString();
      await handleSetUserReports(startDate, endDate);
    } else {
      await handleSetUserReports(props.startDateValue, props.endDateValue);
    }
  };

  const trackLastSuccessfulResult = () => {
    if (props.radioValue === t("LettersReports.radioValue1")) {
      dispatch(setLatestTab(currentActiveTab));
      dispatch(setLatestRadioValue(t("LettersReports.radioValue1")));
    } else {
      dispatch(setLatestTab(currentActiveTab));
      dispatch(setLatestRadioValue(t("LettersReports.radioValue2")));
      dispatch(setLatestStartDate(props.startDateValue));
      dispatch(setLatestEndDate(props.endDateValue));
    }
  };

  const isDetailsNotFound = () => {
    // check if mainReports not empty and special case for letters reports
    // in that case, only one of the arrays must be not empty.

    return !(
      (userMainReports && userMainReports.length) ||
      (props.renderLabel === LETTERS_REPORTS &&
        ((userMainReports && userMainReports.length) ||
          (userAttachedReports && userAttachedReports.length)))
    );
  };

  return (
    <ul key={props.renderLabel}>
      {isDetailsNotFound() ? (
        <DetailsNotFound
          setRadioValue={props.setRadioValue}
          setStartDate={props.setStartDateValue}
          setEndDate={props.setEndDateValue}
        />
      ) : (
       
          handleRenderUserReports()
  
       )}  
    </ul>
  );
};
export default RenderDocDetails;
